import { ICreateArticleDto } from "./Article"
import { Guid, ITranslations } from "@/types"
import ArticleService from "services/ArticleService"
import { prepareTranslations } from "utils/translations"
import { ArticleMachineBase, IGetArticleMachineBaseDto } from "./ArticleMachineBase"

export interface IGetArticleMachineExtDto extends IGetArticleMachineBaseDto {
    descriptionTranslations: ITranslations
    productModelExt?: string // not from API
}

export interface ICreateArticleMachineExtDto extends ICreateArticleDto {
    descriptionTranslations: ITranslations
    productLineId: Guid
    productFamilyId: Guid
    productModelExt: string
    sequence?: number | null
}

export interface IUpdateArticleMachineExtDto {
    descriptionTranslations?: ITranslations
    highLevelArticleNumber?: Guid | null
    lowLevelArticleNumbers?: Guid[] | null
    inspectionRequired?: boolean
    sequence?: number | null
}

export class ArticleMachineExt extends ArticleMachineBase {
    descriptionTranslations: ITranslations
    productModelExt?: Guid

    constructor(dto: IGetArticleMachineExtDto) {
        super(dto)
        this.productModelExt = dto.productModelExt
        this.descriptionTranslations = dto.descriptionTranslations
    }

    #toCreateDto(): ICreateArticleMachineExtDto {
        if (!this.productModelExt) {
            throw new Error("productModelExt is required")
        }

        return {
            articleType: this.articleType,
            isExtManufacturer: this.isExtManufacturer,
            manufacturerDescription: this.manufacturerDescription,
            manufacturerArticleNo: this.manufacturerArticleNo,
            highLevelArticleNumber: this.highLevelArticleNumber,
            lowLevelArticleNumbers: this.lowLevelArticleNumbers,
            descriptionTranslations: prepareTranslations(this.descriptionTranslations),
            drawingNumber: this.drawingNumber,
            productLineId: this.productLineId,
            productFamilyId: this.productFamilyId,
            productModelExt: this.productModelExt,
            imageFileId: this.imageFileId,
            inspectionRequired: this.inspectionRequired,
            sequence: this.sequence,
        }
    }

    #toUpdateDto(): IUpdateArticleMachineExtDto {
        return {
            highLevelArticleNumber: this.highLevelArticleNumber,
            lowLevelArticleNumbers: this.lowLevelArticleNumbers,
            descriptionTranslations: prepareTranslations(this.descriptionTranslations),
            inspectionRequired: this.inspectionRequired,
            sequence: this.sequence,
        }
    }

    create() {
        return ArticleService.createArticle(this.#toCreateDto())
    }

    async update() {
        if (!this.linkUpdate) {
            throw new Error("Update not allowed")
        }
        await ArticleService.updateArticle(this.linkUpdate, this.#toUpdateDto())
    }
}
